module.exports = __webpack_public_path__ + "static/media/EB13.2d5f39fa.png";